(function (global) {
  if (!global || !global.document) return;

  var activeRoots = new WeakSet();
  var guardedComponents = new WeakSet();

  function allowSelectionScroll(event) {
    var target = event.target;
    var root = target && target.closest && target.closest('.bundly__information_app_block');
    if (root) activeRoots.add(root);
  }

  function guardInitialScroll() {
    global.document.querySelectorAll('.bundly__information_app_block bundly-collection-component').forEach(function (component) {
      var root = component.closest('.bundly__information_app_block');
      if (activeRoots.has(root) || guardedComponents.has(component)) return;
      var originalScrollIntoView = component.scrollIntoView;
      if (typeof originalScrollIntoView !== 'function') return;

      // Bundly scrolls on every panel expansion, including its initial render.
      // Guard only these instances until the customer interacts with the bundle.
      component.scrollIntoView = function (options) {
        if (!activeRoots.has(root) && options && options.behavior === 'smooth' && options.block === 'start') return;
        return originalScrollIntoView.apply(this, arguments);
      };
      guardedComponents.add(component);
    });
  }

  guardInitialScroll();
  new global.MutationObserver(function (records) {
    if (records.some(function (record) { return record.addedNodes.length; })) guardInitialScroll();
  }).observe(global.document.documentElement, { childList: true, subtree: true });
  global.document.addEventListener('pointerdown', allowSelectionScroll, true);
  global.document.addEventListener('keydown', allowSelectionScroll, true);

  global.document.addEventListener('click', function (event) {
    allowSelectionScroll(event);
    var target = event.target;
    var header = target && target.closest && target.closest(
      'bundly-collection-component > .bundly__component_header'
    );
    if (!header) return;

    var component = header.parentElement;
    if (
      !component ||
      component.tagName !== 'BUNDLY-COLLECTION-COMPONENT' ||
      component.getAttribute('data-component-expanded') === 'true' ||
      typeof component.scrollIntoView !== 'function'
    ) return;

    var clickedTop = header.getBoundingClientRect().top;
    var restingTop = Math.min(Math.max(clickedTop, 80), Math.round(global.innerHeight * 0.45));
    var originalScrollIntoView = component.scrollIntoView;
    function restore() {
      if (component.scrollIntoView === guardedScrollIntoView) {
        component.scrollIntoView = originalScrollIntoView;
      }
    }
    function guardedScrollIntoView(options) {
      if (options && options.behavior === 'smooth' && options.block === 'start') {
        restore();
        global.requestAnimationFrame(function () {
          var displacement = header.getBoundingClientRect().top - restingTop;
          if (Math.abs(displacement) > 1) {
            global.scrollBy({ top: displacement, behavior: 'instant' });
          }
        });
        return;
      }
      return originalScrollIntoView.apply(this, arguments);
    }

    // Bundly focuses every newly opened component. Keep direct heading clicks in place;
    // navigation from the bundle summary still uses Bundly's normal focus behavior.
    component.scrollIntoView = guardedScrollIntoView;
    global.setTimeout(restore, 2000);
  }, true);
})(typeof window !== 'undefined' ? window : null);
